import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const ExpeditionUpdateFormSchema = z.object({
  request: z.string().min(1, i18nMessage("shared:forms.expeditionUpdate.requestRequired")),
});

export type ExpeditionUpdateFormData = z.infer<typeof ExpeditionUpdateFormSchema>;
